<common-mojo-card>
  <mojo-functions-and-departments-filters
    [pipelineJobStatusFn]="true"
    (filterChange)="applyFilters($event)"
    (jobStatusChange)="jobStatusFilterChanged($event)"
  >
    <mojo-reports-jobs-search-widget
      [selectedDepartment]="selectedDepartment"
      [selectedFunction]="selectedFunction"
      [jobStatus]="jobStatus"
      (sendCandidateOrHiringManagerName)="applyCandidateOrHiringManager($event)"
    >
    </mojo-reports-jobs-search-widget>
  </mojo-functions-and-departments-filters>

</common-mojo-card>
